module.exports = __webpack_public_path__ + "static/media/Menu.bf013861.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Menu/Menu.png
// module id = 200
// module chunks = 0